import { useMemo } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import DiaryDetailView from './components/DiaryDetailView';
import { useGetShortenLink } from '../../domains/shortenLinks/ui/hooks/useGetShortenLink';
import { DIARY_COVER_PRESETS } from '@pocapan/shared/utils/photoCardDiaryCoverStorage';

export default function SharedBinderPage() {
  const { key } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useGetShortenLink(key);
  const payload = data?.payload;

  const collectedPhotoCards = useMemo(() => {
    if (!payload?.photoCardImageUrls) return [];
    return payload.photoCardImageUrls.map((url, index) => ({
      photoCardId: `shared-${index}`,
      pictureUrl: url,
      collectedCount: 1
    }));
  }, [payload?.photoCardImageUrls]);

  const cover = useMemo(() => {
    return {
      colorId: DIARY_COVER_PRESETS[0].id,
      title: payload?.memberName || ''
    };
  }, [payload?.memberName]);

  const closingEngraving = useMemo(() => {
    return {
      eyebrow: payload?.artistName || '',
      title: payload?.memberName || ''
    };
  }, [payload?.artistName, payload?.memberName]);

  return (
    <DiaryDetailView
      collectedPhotoCards={collectedPhotoCards}
      cover={cover}
      memberName={payload?.memberName || ''}
      coverSubtitle={payload?.artistName || ''}
      collectorName={payload?.userNickname || undefined}
      closingEngraving={closingEngraving}
      isLoading={isLoading}
      onBack={() => navigate('/')}
      shareButton={null}
    />
  );
}
